const description = {
  home: {
    desc: " Yathavan prabhakar portfolio home page",
    keywords:
      "react, gatsby,html, css, javascript, web developer, frontend, UI and Ux design",
  },
  about: {
    desc: "Yathavan prabhakar portfolio About page",
    keywords: "bio, experience, skills, about me",
  },
  projects: {
    desc: "Yathavan prabhakar portfolio Projects page",
    keywords: "react projects, gatsby projects, web design, figma",
  },
  contact: {
    desc: "Yathavan prabhakar portfolio contact page",
    keywords: "contact form",
  }
};

export {description}